module.exports = __webpack_public_path__ + "img/04019475000504.52804c9c.png";